import React from "react";
import Progress from "react-progressbar";
import { Modal, Image } from "react-bootstrap";

const LinearProgressModal = ({
  isOpen,
  message,
  progress,
  handleClose,
}) => {

  return (
    <Modal
      size="lg"
      show={isOpen}
      className={`verify light"}`}
    >
      <Modal.Body>
        <div className="progress-div">
          <h3 className="bold">
            {message}
          </h3>
          <p>{progress}%</p>
          <Progress completed={progress} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LinearProgressModal;
